import { render, staticRenderFns } from "./MesuresCovid3.vue?vue&type=template&id=b231f3f8&"
import script from "./MesuresCovid3.vue?vue&type=script&lang=js&"
export * from "./MesuresCovid3.vue?vue&type=script&lang=js&"
import style0 from "./MesuresCovid3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports